import { Box, Divider, useTheme } from "@mui/material";
import { Link, useLocation } from "react-router";

import { RobotoStyledTab, RobotoStyledTabs } from "@/shared/components";
import { useCheckFeatureFlag } from "@/shared/domain/featureFlags/hooks/useCheckFeatureFlag";

import { useActiveDeviceTab, DeviceTab } from "./useActiveDeviceTabFromUrl";

interface DeviceTabsProps {
  deviceId: string;
}

export function DeviceTabs(_props: DeviceTabsProps) {
  const theme = useTheme();
  // Derived from the URL each tab's <Link> navigates to, so there is no local
  // tab state that could drift from the address bar.
  const activeTab = useActiveDeviceTab();
  const location = useLocation();
  // Show the Sessions tab only when `release-sessions` is on.
  // The same flag gates the /devices/:deviceId/sessions route in DevicesRoutes.tsx, so
  // hiding the tab here keeps the strip aligned with reachable routes.
  const sessionsTabEnabled = useCheckFeatureFlag("release-sessions");
  // Same flag gates the /devices/:deviceId/metrics route in DevicesRoutes.tsx.
  const metricsTabEnabled = useCheckFeatureFlag("release-metrics");

  return (
    <Box
      sx={{
        marginTop: theme.spacing(1),
      }}
    >
      <RobotoStyledTabs value={activeTab}>
        {sessionsTabEnabled && (
          <RobotoStyledTab
            value={DeviceTab.Sessions}
            label="Sessions"
            component={Link}
            to={{
              pathname: DeviceTab.Sessions,
              search: location.search,
            }}
            replace
          />
        )}
        <RobotoStyledTab
          value={DeviceTab.Datasets}
          label="Datasets"
          component={Link}
          to={{
            pathname: DeviceTab.Datasets,
            search: location.search,
          }}
          replace
        />
        <RobotoStyledTab
          value={DeviceTab.Files}
          label="Files"
          component={Link}
          to={{
            pathname: DeviceTab.Files,
            search: location.search,
          }}
          replace
        />
        {metricsTabEnabled && (
          <RobotoStyledTab
            value={DeviceTab.Metrics}
            label="Metrics"
            component={Link}
            to={{
              pathname: DeviceTab.Metrics,
              search: location.search,
            }}
            replace
          />
        )}
        <RobotoStyledTab
          value={DeviceTab.Details}
          label="Details"
          component={Link}
          to={{
            pathname: DeviceTab.Details,
            search: location.search,
          }}
          replace
        />
        <RobotoStyledTab
          value={DeviceTab.Tokens}
          label="Tokens"
          component={Link}
          to={{
            pathname: DeviceTab.Tokens,
            search: location.search,
          }}
          replace
        />
      </RobotoStyledTabs>
      <Divider
        sx={{
          borderColor: theme.border.color,
        }}
      />
    </Box>
  );
}
